import { createApp } from 'vue';

import ConsumerTestimonialsCarousel from './consumerTestimonialsCarousel.vue';
import ConsumerTestimonialsVideoBlock from './consumerTestimonialsVideoBlock.vue';

import './consumerTestimonialsVideo.scss';
import 'Features/Shared/Views/CaptionLocalBlock/CaptionLocalBlock-entry.scss';

const consumerTestimonialsVideoBlocks = document.querySelectorAll<HTMLElement>(
	'[data-feature="consumerTestimonialsVideo"]',
);

consumerTestimonialsVideoBlocks.forEach((consumerTestimonialsVideoBlock) => {
	const app = createApp({
		name: 'ConsumerTestimonialsVideoApp',
	});

	app.component('consumer-testimonials-carousel', ConsumerTestimonialsCarousel);
	app.component('consumer-testimonials-video-block', ConsumerTestimonialsVideoBlock);
	app.mount(consumerTestimonialsVideoBlock);
});
